import React from "react";
import { Modal, Box, makeStyles } from "@material-ui/core";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import { ScenarioCreationContent } from "./ScenarioCreationContent";
import PropTypes from "prop-types";

const useStyles = makeStyles((theme) => ({
  modalBox: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "80%",
    backgroundColor: theme.palette.background.paper,
    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.15)",
    maxHeight: "90vh",
    overflowY: "auto",
    padding: theme.spacing(1),
    borderRadius: "8px",
    overflow: "clip",
  },
  cardBody: {
    padding: 0,
  },
}));

export const ScenarioCreationDrawer = ({
  open,
  onClose,
  scenarios,
  isLoading = false,
}) => {
  const classes = useStyles();

  return (
    <Modal
      open={open}
      onClose={() => onClose(false)}
      aria-labelledby="new-scenario-modal-title"
      aria-describedby="new-scenario-modal-description"
    >
      <Box className={classes.modalBox}>
        <Card>
          <CardBody className={classes.cardBody}>
            <ScenarioCreationContent
              onClose={onClose}
              scenarios={scenarios}
              isLoading={isLoading}
            />
          </CardBody>
        </Card>
      </Box>
    </Modal>
  );
};

ScenarioCreationDrawer.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  scenarios: PropTypes.array,
  isLoading: PropTypes.bool,
};
